import type { UploadProps } from "antd";
import { Upload } from "antd";
import { Assets } from "../../../assets";
import style from "./style.module.scss";
import { useState } from "react";
import "./style.scss";

type UploadType = {
  fileList?: Array<any>;
  onChange?: (e: any) => void;
  multiple?: boolean;
  disabled?: boolean;
  name?: string;
  placeholder?: string;
  onDelete?: (id: number) => void;
  className?: string;
  children?: React.ReactNode;
  inputStyle?: boolean;
  isExcelOnly?: boolean;
};

const EXCEL_TYPE = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  "application/vnd.ms-excel.template.macroEnabled.12",
  "application/wps-office.xlsx",
];

export const UploadInputFile = ({
  fileList,
  onChange,
  name,
  multiple = false,
  disabled,
  className,
  onDelete,
  isExcelOnly,
}: UploadType) => {
  const [errorMessage, setErrorMessage] = useState<string>("");

  const beforeUpload = (file: File) => {
    const isExcel = EXCEL_TYPE.includes(file.type);

    if (!isExcel) {
      // message.error("You can only upload Excel files!");
      setErrorMessage("Veuillez importer uniquement un fichier Excel.");
      return Upload.LIST_IGNORE;
    }
    return false;
  };

  const onChangeFile: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    setErrorMessage("");
    if (name) {
      onChange && onChange({ [name]: newFileList });
    } else {
      onChange && onChange(newFileList);
    }
  };

  return (
    <div>
      <div className={`${style.upload_item} custom_upload`}>
        <Upload
          fileList={fileList}
          // beforeUpload={() => false}
          onChange={onChangeFile}
          multiple={multiple}
          disabled={disabled}
          className={className}
          {...(!multiple ? { maxCount: 1 } : {})}
          {...(onDelete
            ? {
                onRemove: (e: any) => e?.id && onDelete(e?.id as number),
              }
            : {})}
          {...(isExcelOnly
            ? {
                beforeUpload,
                accept: ".xls,.xlsx",
              }
            : {
                beforeUpload: () => false,
              })}
        >
          <div className={style.upload_attach_wrapper}>
            <img
              src={Assets.images.attach}
              alt=""
              className={style.upload_attach}
            />
          </div>
        </Upload>
      </div>
      <span className={style.error_message}> {errorMessage} </span>
    </div>
  );
};
